export default __webpack_public_path__ + "static/Auryxia-logo-6b7304942286c8fbe2db2fcc25c498da.svg";